// image
import icon from '../../assets/img/real-time.svg';
import { AnimationWrap } from '../../helper/animationWrap';

export const Image = () => {
	return (
		<AnimationWrap tag="span" animationClass="show-animation-1">
			<img width="120" height="120" src={icon} alt="real time icon" />
		</AnimationWrap>
	);
};
